export default "__VITE_ASSET__Bz7H6TLr__"